import { MAX_FILE_SIZE, MAX_FILE_SIZE_MB } from "./constants";

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordPattern =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,50}$/;

export function validateFileSize(file) {
  if (!file) return null;
  if (file.size > MAX_FILE_SIZE) {
    return `File size must be less than ${MAX_FILE_SIZE_MB}MB.`;
  }
  return null;
}

export function validateFileType(file, allowedTypes = ['application/pdf']) {
  if (!file) return null;
  if (!allowedTypes.includes(file.type)) {
    return "Invalid file type. Only PDF files are allowed.";
  }
  return null;
}

export function validateLogin(values) {
  const errors = {};

  if (!values.username.trim()) {
    errors.username = "Username is required.";
  }

  if (!values.password.trim()) {
    errors.password = "Password is required.";
  }

  return errors;
}

export function validateRegister(values) {
  const errors = {};

  if (!values.username.trim()) {
    errors.username = "Username is required.";
  } else if (values.username.trim().length < 3) {
    errors.username = "Username must be at least 3 characters.";
  }

  if (!values.fullName.trim()) {
    errors.fullName = "Full name is required.";
  } else if (values.fullName.trim().length < 3) {
    errors.fullName = "Full name must be at least 3 characters.";
  }

  if (!values.email.trim()) {
    errors.email = "Email is required.";
  } else if (!emailPattern.test(values.email)) {
    errors.email = "Enter a valid email address.";
  }

  if (!values.password.trim()) {
    errors.password = "Password is required.";
  } else if (!passwordPattern.test(values.password)) {
    errors.password =
      "Use 8-50 characters with uppercase, lowercase, number, and special character.";
  }

  if (!values.confirmPassword.trim()) {
    errors.confirmPassword = "Confirm your password.";
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = "Passwords do not match.";
  }

  if (!values.roleId) {
    errors.roleId = "Please select a role.";
  }

  return errors;
}

export function validateForgotPasswordEmail(email) {
  const errors = {};

  if (!email.trim()) {
    errors.email = "Email is required.";
  } else if (!emailPattern.test(email)) {
    errors.email = "Enter a valid email address.";
  }

  return errors;
}

export function validateVerifyOtp(otp) {
  const errors = {};

  if (!otp.trim()) {
    errors.otp = "OTP is required.";
  } else if (!/^\d{6}$/.test(otp)) {
    errors.otp = "OTP must be a 6-digit number.";
  }

  return errors;
}

export function validateResetPassword(values) {
  const errors = {};

  if (!values.newPassword.trim()) {
    errors.newPassword = "New password is required.";
  } else if (!passwordPattern.test(values.newPassword)) {
    errors.newPassword =
      "Use 8-50 characters with uppercase, lowercase, number, and special character.";
  }

  if (!values.confirmPassword.trim()) {
    errors.confirmPassword = "Confirm your password.";
  } else if (values.confirmPassword !== values.newPassword) {
    errors.confirmPassword = "Passwords do not match.";
  }

  return errors;
}
